import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { MAX_DESKTOP_WIDTH, MAX_MOBILE_WIDTH } from '../constants/app'

const getMaxWidthInPx = (
  options:
    | {
        maxWidth: number | string
        deviceType: DEVICE_TYPES
      }
    | {
        maxWidthDesktopInRem: number | string
        maxWidthMobileInRem: number | string
        deviceType: DEVICE_TYPES
      },
) => {
  const maxWidthDesktopInRem = 'maxWidth' in options ? options.maxWidth : options.maxWidthDesktopInRem
  const maxWidthMobileInRem = 'maxWidth' in options ? options.maxWidth : options.maxWidthMobileInRem

  const isMobile = options.deviceType === DEVICE_TYPES.MOBILE
  const maxValueOfOneRemInPx = isMobile ? MAX_MOBILE_WIDTH * 0.026666 : MAX_DESKTOP_WIDTH * 0.0069444444444444

  return Math.round(
    isMobile ? maxValueOfOneRemInPx * Number(maxWidthMobileInRem) : Number(maxWidthDesktopInRem) * maxValueOfOneRemInPx,
  )
}

export default getMaxWidthInPx
